export default __webpack_public_path__ + "static/media/page1.d53a9a95.png";